import type { App } from '@grafikr/components';

import intersectionLoader from 'utils/loaders/intersection';
import onElementInteraction from 'utils/loaders/on-element-interaction';
import onEvent from "../utils/loaders/on-event";

import productItem from 'components/product-item';
import quickBuy from 'components/quick-buy';
import anchors from "components/anchor-links";
import geoModal from "components/geo-modal";
import pagination from "components/pagination";
import cartDrawer from "components/cart-drawer";

export default (app: App) => {
  app.add({
    // Layout
    header: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-header" */ 'components/header'),
    ],
    anchors,

    // Components
    pagination,
    'address-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-address-form" */ 'components/address-form'),
    ],
    'cart-drawer': cartDrawer,
    'search-drawer': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-search-drawer" */ 'components/search-drawer'),
    ],
    'cart-count': [
      onEvent,
      () => import(/* webpackChunkName: "component-cart-count" */ 'components/cart-count'),
    ],
    copy: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-copy" */ 'components/copy'),
    ],
    drawer: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-drawer" */ 'components/drawer'),
    ],
    'lazy-content': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-lazy-content" */ 'components/lazy-content'),
    ],
    video: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-video" */ 'components/video'),
    ],
    slider: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-slider" */ 'components/slider'),
    ],
    'image-carousel': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-image-carousel" */ 'components/image-carousel'),
    ],
    'mobile-menu': [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-mobile-menu" */ 'components/mobile-menu'),
    ],
    trigger: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-trigger" */ 'components/trigger'),
    ],
    'instagram-gallery': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-instagram-gallery" */ 'components/instagram-gallery'),
    ],
    'featured-collections': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-featured-collections" */ 'components/featured-collections'),
    ],
    collapsible: [
      'click',
      () => import(/* webpackChunkName: "component-collapsible" */ 'components/collapsible'),
    ],
    'selling-plan': [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-selling-plan" */ 'components/selling-plan'),
    ],
    stepper: [
      intersectionLoader,
      () => import(/* webpackChunkName: "component-stepper" */ 'components/stepper'),
    ],
    'product-item-linked-products': [
      'change',
      () =>
        import(
          /* webpackChunkName: "component-product-item-linked-products" */ 'components/product-item-linked-products'
          ),
    ],
    'product-item': productItem,
    'quick-buy': quickBuy,
    'geo-modal': geoModal,
    share: [
      onElementInteraction,
      () => import(/* webpackChunkName: "component-share" */ 'components/share'),
    ],
    'style-on-stick': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "collection-style-on-stick" */ 'components/style-on-stick'),
    ],

    // Pages
    product: [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-main" */ 'pages/product/main'),
    ],
    'product-form': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-form" */ 'pages/product/form'),
    ],
    'product-media': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-media" */ 'pages/product/media'),
    ],
    'product-lightbox': [
      intersectionLoader,
      () => import(/* webpackChunkName: "product-lightbox" */ 'pages/product/lightbox'),
    ],
    'product-recommendations': [
      intersectionLoader,
      () =>
        import(/* webpackChunkName: "product-recommendations" */ 'pages/product/recommendations'),
    ],
    'product-ingredients-modal': [
      onElementInteraction,
      () => import(/* webpackChunkName: "product-ingredients-modal" */ 'pages/product/ingredients-modal'),
    ],
  });
};
